module.exports = __webpack_public_path__ + "static/assets/9146f5bc3c735284fc46313b40b38c50.svg";